import { SendOutlined, ClearOutlined } from '@ant-design/icons';
import { Button, Input, Tooltip } from 'antd';
import { useCallback } from 'react';

import type { AiChatInputProps } from '@pages/AiAgents/types';

import type { ChangeEvent, FC, KeyboardEvent } from 'react';

const { TextArea } = Input;

export const AiChatInput: FC<AiChatInputProps> = ({
  value,
  disabled,
  loading,
  onChange,
  onSend,
  isResetting,
  onReset,
}) => {
  const handleChange = useCallback(
    ({ target: { value } }: ChangeEvent<HTMLTextAreaElement>) => {
      onChange(value);
    },
    [onChange]
  );

  const handlePressEnter = useCallback(
    async (event: KeyboardEvent<HTMLTextAreaElement>) => {
      if (!event.shiftKey) {
        event.preventDefault();

        if (!disabled && !loading && value.trim()) {
          await onSend();
        }
      }
    },
    [disabled, loading, onSend, value]
  );

  const handleClickSend = useCallback(async () => {
    if (!disabled && !loading && value.trim()) {
      await onSend();
    }
  }, [disabled, loading, onSend, value]);

  const isSendDisabled = disabled || !value.trim();

  return (
    <div className="ai-agents-chat-input">
      <TextArea
        value={value}
        onChange={handleChange}
        onPressEnter={handlePressEnter}
        autoSize={{ minRows: 3, maxRows: 5 }}
        disabled={disabled}
        placeholder="Напишите сообщение ИИ-агенту..."
      />
      <Tooltip title="Отправить сообщение">
        <Button
          shape="circle"
          icon={<SendOutlined />}
          onClick={handleClickSend}
          loading={loading}
          disabled={isSendDisabled}
          className="ai-agents-chat-input__send-button"
        />
      </Tooltip>
      <Tooltip title="Сбросить контекст чата">
        <Button
          onClick={onReset}
          loading={isResetting}
          disabled={disabled}
          className="ai-agents-chat-input__reset-button"
          icon={<ClearOutlined />}
        />
      </Tooltip>
    </div>
  );
};
